<template>
    <PlansViewsSection />
</template>

<script>
import PlansViewsSection from '@/components/plans/PlansViewsSection.vue';

export default {
    components: {
        PlansViewsSection,
    },
}
</script>